/* yn-extras.js: additions made after the launch (13 Oct). Loaded by yn-head, deferred, after yn-fixes.js.
   1. Product card: the colour dots are buttons. Tapping one shows that colour on the card (photo and sizes), and the product
      page and quick add then open on that colour.
   2. Product page: a link that ends in #colour=Name opens on that colour (no size is chosen for the visitor).
   3. Hand-drawn photo frames: no hairline of photo outside the frame. */
(function () {
  if (window.__ynExtras) return;
  window.__ynExtras = true;
  var doc = document;

  function T(s, p) {
    var Y = window.Yuno;
    return Y && typeof Y.T === 'function' ? Y.T(s, p) : String(s);
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* "3-4 years:2,4-5 years:-1" -> { '3-4 years': 2, '4-5 years': -1 }. 0 sold out, -1 in stock, otherwise units left. */
  function stockMap(str) {
    var m = {};
    String(str || '').split(',').forEach(function (p) {
      var i = p.lastIndexOf(':');
      if (i < 1) return;
      var k = p.slice(0, i), n = parseInt(p.slice(i + 1), 10);
      if (isNaN(n)) return;
      if (m[k] === undefined || m[k] === 0) m[k] = n;
    });
    return m;
  }

  /* The card's line for the remembered age ("3 left in 3-4 years"), written again for the chosen colour.
     Same wording and rules as cardAge in yn-core.js. */
  function ageLine(card) {
    var Y = window.Yuno;
    var size = Y && Y.size && typeof Y.size.get === 'function' ? Y.size.get() : null;
    var line = card.querySelector('[data-yn-age]');
    if (!line || !size || card.getAttribute('data-available') !== 'true') return;
    var n = stockMap(card.getAttribute('data-stock'))[size], text, good = true, icon = 'tick';
    if (n === undefined) { text = T('Not made in [n]', { n: T(size) }); good = false; icon = 'close'; }
    else if (n === 0) { text = T('Sold out in [n]', { n: T(size) }); good = false; icon = 'close'; }
    else if (n > 0) text = T('[n] left in [a]', { n: n, a: T(size) });
    else text = T('In stock in [n]', { n: T(size) });
    line.className = 'yn-card__age' + (good ? '' : ' is-no');
    line.innerHTML = (window.YK && window.YK.icon ? window.YK.icon(icon, 14) : '') + '<span></span>';
    line.lastChild.textContent = text;
  }

  function pickColour(card, btn) {
    var name = btn.getAttribute('data-yn-card-colour');
    if (!name) return;
    each(card.querySelectorAll('[data-yn-card-colour]'), function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    card.setAttribute('data-yn-picked', name);

    /* photo: this colour's; the second photo shown on hover belongs to the first colour, so it goes */
    var src = btn.getAttribute('data-src');
    var photo = card.querySelector('.yn-card__photo');
    var img = card.querySelector('.yn-card__photo > img');
    /* the page-to-page morph would start from this colour's photo and land on the product's first one: switch it off for this card */
    if (photo && photo.style) photo.style.viewTransitionName = 'none';
    if (src && img && img.getAttribute('src') !== src) {
      var set = btn.getAttribute('data-srcset');
      if (set) img.setAttribute('srcset', set); else img.removeAttribute('srcset');
      img.setAttribute('src', src);
    }
    var media = card.querySelector('.yn-card__media');
    if (media) {
      media.removeAttribute('data-yn-hover-src');
      var alt = media.querySelector('.yn-card__alt');
      if (alt && alt.parentNode) alt.parentNode.removeChild(alt);
    }

    /* link: the product page opens on this colour */
    var link = card.querySelector('.yn-card__link');
    if (link) {
      var href = String(link.getAttribute('href') || '').split('#')[0];
      if (href) link.setAttribute('href', href + '#colour=' + encodeURIComponent(name));
    }

    /* sizes: what this colour has. The card's data-sizes stays as the server wrote it (every colour together): the home rows
       and the product page's "in stock in your size" block filter on it, and the product is still in stock in another colour. */
    var stock = btn.getAttribute('data-stock') || '';
    var map = stockMap(stock);
    each(card.querySelectorAll('.yn-card__size[data-s]'), function (cell) {
      var k = cell.getAttribute('data-s'), n = map[k], out = n === undefined || n === 0;
      cell.classList.toggle('is-out', out);
      var vh = cell.querySelector('.yn-vh');
      if (vh) vh.textContent = out ? T('[a], sold out', { a: T(k) }) : T(k);
    });
    if (card.querySelector('.yn-card__size[data-s]')) {
      card.setAttribute('data-stock', stock);
      ageLine(card);
    }
    var Y = window.Yuno;
    if (Y && typeof Y.announce === 'function') { try { Y.announce(T('Colour: [n]', { n: name })); } catch (x) {} }
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var dot = t.closest('[data-yn-card-colour]');
    if (dot) {
      var card = dot.closest('.yn-card');
      if (!card) return;
      e.preventDefault();
      e.stopPropagation();
      try { pickColour(card, dot); } catch (x) {}
      return;
    }
    /* quick add from a card whose colour was chosen: the sheet opens on that colour */
    var q = t.closest('[data-yn-quick-add]');
    if (!q) return;
    var qc = q.closest('.yn-card');
    var colour = qc ? qc.getAttribute('data-yn-picked') : '';
    var Y = window.Yuno;
    if (!colour || !Y || !Y.quickAdd || typeof Y.quickAdd.open !== 'function') return;
    e.preventDefault();
    e.stopPropagation();
    Y.quickAdd.open(q.getAttribute('data-yn-quick-add'), { opener: q, source: 'card', colour: colour });
  }, true);

  /* Product page: #colour=Name selects that colour's swatch. A ?variant= link already selects a colour, so it wins.
     yn-product.js may not be listening yet on a slow phone, so the tap is tried again until the swatch shows as pressed. */
  function colourFromHash(tries) {
    var m = /(?:^#|&)colour=([^&]+)/.exec(window.location.hash || '');
    if (!m || /[?&]variant=/.test(window.location.search || '')) return;
    var want;
    try { want = decodeURIComponent(m[1]); } catch (x) { return; }
    var btn = null;
    each(doc.querySelectorAll('button[data-yn-colour]'), function (b) {
      if (!btn && b.getAttribute('data-yn-colour') === want) btn = b;
    });
    if (!btn || btn.getAttribute('aria-pressed') === 'true') return;
    btn.click();
    var left = tries === undefined ? 6 : tries;
    if (left > 0) setTimeout(function () { try { colourFromHash(left - 1); } catch (x) {} }, 400);
  }

  /* Hand-drawn frames (yn-kit.js): the page-coloured cut around the photo is drawn in whole pixels, and a photo box is often
     a fraction of a pixel larger (131.44px), which left a hairline of photo outside the frame. The cut now runs 3px past the box. */
  function widenMat(host) {
    var p = host.querySelector('.yn-frame-layer > svg > path');
    if (!p) return;
    var d = p.getAttribute('d') || '', m = /^M0 0H(\d+)V(\d+)H0Z/.exec(d);
    if (m) p.setAttribute('d', 'M-3 -3H' + (Number(m[1]) + 3) + 'V' + (Number(m[2]) + 3) + 'H-3Z' + d.slice(m[0].length));
  }
  function frames() {
    var F = window.YK && window.YK.frame;
    if (F && typeof F.render === 'function' && !F.__ynWide) {
      var render = F.render;
      F.render = function (host) {
        var r = render.apply(this, arguments);
        try { widenMat(host); } catch (x) {}
        return r;
      };
      F.__ynWide = true;
    }
    each(doc.querySelectorAll('[data-yn-frame]'), function (h) { try { widenMat(h); } catch (x) {} });
  }

  function run() {
    try { frames(); } catch (x) {}
    try { colourFromHash(); } catch (x) {}
  }
  try { frames(); } catch (x) {}
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { setTimeout(run, 80); });
  else setTimeout(run, 80);
  doc.addEventListener('shopify:section:load', function () { setTimeout(function () { try { frames(); } catch (x) {} }, 80); });
})();
